@if (showCrumbs()) {
  <nav class="breadcrumbs bg-default-100 pt-1 pb-1">
    <div class="main-column flex items-center min-h-8">
      <ul class="library-crumbs ml-1">
        @for (crumb of breadcrumbs(); track crumb.key) {
          <li class="inline-block">
            @if (crumb.routerLink) {
              <a [routerLink]="crumb.routerLink" class="underline" (click)="trackBreadcrumbClick(crumb.label)">
                <span [ngClass]="crumb.klasses">{{ crumb.label }}</span>
              </a>
            } @else {
              <span [ngClass]="crumb.klasses">{{ crumb.label }}</span>
            }
            @if (!crumb.lastItem) {
              <span class="ml-1 mr-1 text-large">&rsaquo;</span>
            }
          </li>
        }
      </ul>
      @if (showRightButton()) {
        @let rb = rightButton();
        @if (rb) {
          <div class="ml-auto mr-1">
            <div class="bg-default-yellow p-1 pl-2 pr-2 rounded-lg">
              <a [routerLink]="rb.routerLink" (click)="trackPlaylistClick()">
                <span [ngClass]="rb.klasses">{{ rb.label }}</span>
              </a>
            </div>
          </div>
        }
      }
    </div>
  </nav>
}
